<template>
  <a-button type="link" @click="showModal">指定品置顶</a-button>
  <a-modal v-model:visible="visible" title="指定品置顶" width="70%">
    <a-form ref="formRef" :model="formState" v-bind="layout">
      <a-row :gutter="[16]">
        <a-col span="8">
          <a-form-item label="id" name="id">
            <a-input
              v-model:value="formState.id"
              placeholder="请输入"
              :maxlength="10"
            />
          </a-form-item>
        </a-col>
        <a-col span="8">
          <a-form-item label="skcCode" name="skcCode">
            <a-input
              v-model:value="formState.skcCode"
              placeholder="请输入"
              :maxlength="50"
            />
          </a-form-item>
        </a-col>
        <a-col span="8">
          <a-form-item label="备注" name="remark">
            <a-input
              v-model:value="formState.remark"
              placeholder="请输入"
              :maxlength="500"
            />
          </a-form-item>
        </a-col>
        <a-col
          :span="8"
          :offset="16"
          style="margin-bottom:24px;text-align:right"
        >
          <a-space>
            <a-button @click="reset">重置</a-button>
            <a-button type="primary" @click="handleQuery">查询</a-button>
          </a-space>
        </a-col>
      </a-row>
    </a-form>
    <a-table
      :dataSource="dataSource"
      :columns="columns"
      :pagination="pagination"
      bordered
      :scroll="{ x: 1300 }"
      :loading="tableLoading"
    >
      <template #bodyCell="{ column,record }">
        <template v-if="['action'].includes(column.key)">
          <a-popconfirm
            v-if="dataSource.length"
            title="确定删除该指定品置顶?"
            @confirm="onDelete(record.id)"
            okText="确定"
            cancelText="取消"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
        <template v-if="['skcCodes'].includes(column.key)">
          <span style="word-break: break-all">
            {{ record.skcCodes.join(';') }}
          </span>
        </template>
        <template v-if="['lastUpdateTime'].includes(column.key)">
          {{ dayjs(record.lastUpdateTime).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template v-if="['id'].includes(column.key)">
          <a-button type="link" @click="getDetailById(record)">{{
            record.id
          }}</a-button>
        </template>
        <template v-if="['remark'].includes(column.key)">
          <a-tooltip placement="topRight" :title="record.remark">
            <!-- :get-popup-container="getPopupContainer" -->
            <p class="elllipsis">{{ record.remark }}</p>
          </a-tooltip>
        </template>
        <template v-if="['url'].includes(column.key)">
          <a-typography-paragraph
            v-if="record.url"
            :copyable="{
              text: record.url,
              tooltip: true,
              onCopy: () => message.success('复制成功')
            }"
          >
            {{ record.url }}
          </a-typography-paragraph>
        </template>
      </template>
    </a-table>

    <template #footer>
      <a-button type="primary" @click="addAssinProduct"
        >新增指定商品置顶</a-button
      >
    </template>
  </a-modal>
  <a-modal
    v-model:visible="isVisible"
    :title="`${id ? '修改' : '新增'}指定商品置顶`"
    width="70%"
  >
    <a-form-item>
      <template #label>
        <span style="margin-right: 5px;">批量添加SKC</span>
        <a-tooltip placement="topLeft" title="最多一次性添加50个skc">
          <exclamation-circle-outlined style="color: red" />
        </a-tooltip>
      </template>
      <div style="display: flex; align-items: center">
        <a-select
          v-model:value="skcInputList"
          mode="tags"
          style="flex: 1; margin-right: 10px"
          placeholder="请输入SKC，支持复制粘贴（空格、逗号分隔）"
          :token-separators="[',', ' ', '\n']"
          :open="false"
        ></a-select>
        <a-button type="primary" :loading="loading" @click="batchAdd"
          >批量添加</a-button
        >
      </div>
    </a-form-item>
    <a-form-item label="备注">
      <a-input placeholder="请输入" :maxlength="500" v-model:value="remark" />
    </a-form-item>

    <drag-table
      rowKey="id"
      :dataSource="dataSource1"
      :columns="columns2"
      :pagination="false"
      is-drag
      bordered
      @dragChange="dragChange"
      v-if="isVisible"
    >
      <template #skcCode="{record,index}">
        <div class="msg">
          <div :class="record.msg ? 'errormsg' : ''">
            <a-input
              v-model:value="record.skcCode"
              @blur="onBlur(record)"
              allow-clear
              @change="e => onChange(e, record, index)"
            />
          </div>
          <div class="err-tips" style="margin-top: 8px;" v-if="record.msg">
            {{ record.msg }}
          </div>
        </div>
      </template>
      <template #imgUrl="{record}">
        <img
          v-if="record.imgUrl"
          :src="record.imgUrl + suffix"
          width="80"
          alt=""
        />
      </template>
      <template #id>
        <holder-outlined />
      </template>
      <template #priority="{index}">
        {{ index + 1 }}
      </template>
      <template #action="{index}">
        <a-button type="link" @click="removeRow(index)">删除</a-button>
      </template>
    </drag-table>
    <a-button block type="dashed" style="margin-top: 20px;" @click="addRow"
      >新增指定商品</a-button
    >
    <template #footer>
      <a-button @mousedown="submit">取消</a-button>
      <a-button type="primary" @click="handleConfirm">{{
        id ? '修改' : '确认'
      }}</a-button>
    </template>
  </a-modal>
</template>

<script>
import { message } from 'ant-design-vue'
import { inject, reactive, toRefs, watchEffect } from 'vue'
import {
  admin_col_top_check_skc,
  admin_col_top_page,
  admin_col_top_save,
  admin_col_top_delete,
  admin_col_top_get_detail
} from '@/server/modules/producttop.js'
import DragTable from './DragTable.vue'
import {
  HolderOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons-vue'
import dayjs from 'dayjs'

export default {
  name: 'AssignProduct',
  components: { DragTable, HolderOutlined, ExclamationCircleOutlined },
  props: {
    colId: Number
  },
  setup(props) {
    const init = inject('initState')

    const state = reactive({
      visible: false,
      isVisible: false,
      tableLoading: false,
      dataSource: [],
      dataSource1: [],
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width: 100
        },
        {
          title: 'SkcCode',
          dataIndex: 'skcCodes',
          key: 'skcCodes',
          width: 200
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
          // ellipsis: true,
          width: 200
        },
        {
          title: '链接',
          dataIndex: 'url',
          key: 'url',
          width: 200
        },
        {
          title: '最近修改人',
          dataIndex: 'updator',
          key: 'updator',
          width: 100
        },
        {
          title: '最近修改时间',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime',
          width: 200
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          width: 100
        }
      ],
      columns2: [
        {
          title: '',
          dataIndex: 'id',
          key: 'id',
          width: 40,
          slots: { customRender: 'id' }
        },
        {
          title: '优先级',
          dataIndex: 'priority',
          key: 'priority',
          width: 100,
          slots: { customRender: 'priority' }
        },
        {
          title: 'SKC CODE',
          dataIndex: 'skcCode',
          key: 'skcCode',
          // class: 'skcTitle',
          slots: { customRender: 'skcCode' },
          width: 200
        },
        {
          title: '产品标题',
          dataIndex: 'title',
          key: 'title',
          width: 100
        },
        {
          title: '商品图片',
          dataIndex: 'imgUrl',
          key: 'imgUrl',
          width: 100,
          slots: { customRender: 'imgUrl' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          width: 100,
          slots: { customRender: 'action' }
        }
      ],

      pagination: {
        current: 1,
        defaultPageSize: 5,
        defaultCurrent: 1, //默认的当前页数
        pageSize: 5, //每页显示几条数据
        showQuickJumper: true, //是否显示直通车
        total: 0, //总数
        pageSizeOptions: ['5', '10', '20', '50'],
        showSizeChanger: true,
        showLessItems: true,
        showTotal: total => `共${total}条数据`,
        onShowSizeChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.queryList()
        },
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.queryList()
        }
      },
      showModal() {
        state.visible = true
        state.reset()
      },
      loading: false,
      async addRow() {
        let isEmpty = false
        state.dataSource1.filter(e => {
          if (!e.skcCode) {
            e.msg = 'SKC不存在，请重新输入'
            isEmpty = true
            return
          }
          if (e.msg) {
            isEmpty = true
            return
          }
        })

        if (isEmpty) {
          return
        }
        // const ishasRepeatCode = state.dataSource1.

        // if (condition) {

        // }

        const row = {
          priority: state.dataSource1.length + 1,
          imgUrl: '',
          skcCode: ''
        }
        state.dataSource1.push(row)
      },
      skcInputList: [],
      async batchAdd() {
        if (!state.skcInputList.length) {
          message.warning('请输入SKC')
          return
        }
        if (state.skcInputList.length > 50) {
          message.warning('最多输入50个SKC')
          return
        }
        const params = {
          ...init.searchParams,
          skcCodes: state.skcInputList,
          colId: props.colId
        }
        state.loading = true
        try {
          const { success, data } = await admin_col_top_check_skc(params)
          if (success) {
            const newRows = []
            Object.keys(data).forEach(skcCode => {
              const item = data[skcCode]
              // 检查是否已经存在
              const exist = state.dataSource1.some(v => v.skcCode === skcCode)
              if (!exist) {
                newRows.push({
                  priority: state.dataSource1.length + 1 + newRows.length,
                  imgUrl: item.imgUrl,
                  skcCode: skcCode,
                  title: item.title,
                  msg: null
                })
              }
            })
            if (newRows.length) {
              state.dataSource1.push(...newRows)
              state.skcInputList = []
              message.success(`成功添加${newRows.length}条数据`)
            } else {
              message.warning('没有可添加的有效数据或数据已存在')
            }
          } else {
            message.error('批量添加失败，请检查skcCode是否异常')
          }
        } catch (err) {
          console.error(err)
        } finally {
          state.loading = false
        }
      },
      checkSkcs(skcCodes, record = null) {
        const params = {
          ...init.searchParams,
          skcCodes,
          colId: props.colId
        }
        state.loading = true
        admin_col_top_check_skc(params, { loading: false })
          .then(({ success, data, retInfo }) => {
            if (success) {
              const skc = skcCodes[0] ? skcCodes[0].toUpperCase() : ''
              record.imgUrl = data[skc].imgUrl
              record.title = data[skc].title
              record.msg = null
              state.loading = false
            } else {
              record.msg = retInfo //'SKC不存在，请重新输入'
              state.loading = false
            }
          })
          .catch(err => {
            console.log('err', err)
            record.msg = 'SKC不存在，请重新输入'
            state.loading = false
          })
      },
      async onBlur(record) {
        if (record.skcCode === '') return
        const filteredArray = state.dataSource1.filter(
          item => item.skcCode === record.skcCode
        )
        if (filteredArray.length > 1) {
          record.msg = 'SKC重复'
          return
        }
        state.checkSkcs([record.skcCode], record)
      },

      dragChange(data) {
        console.log('data', data)
        const sourceIndex = state.dataSource1.findIndex(
          v => v.skcCode === data.source.skcCode
        )
        const targetIndex = state.dataSource1.findIndex(
          v => v.skcCode === data.target.skcCode
        )
        console.log(sourceIndex, targetIndex)
        state.dataSource1[targetIndex] = data.source
        state.dataSource1[sourceIndex] = data.target
      },
      async queryList() {
        const params = {
          ...init.searchParams,
          pageSize: state.pagination.pageSize,
          pageNum: state.pagination.current,
          colId: props.colId,
          ...state.formState
        }
        state.tableLoading = true
        try {
          let { success, data, retInfo } = await admin_col_top_page(params)
          if (success) {
            state.dataSource = data.list
          } else {
            message.error(retInfo)
          }
          setTimeout(() => {
            state.tableLoading = false
          }, 100)
        } catch (err) {
          state.tableLoading = false
        }
      },
      async onDelete(id) {
        const params = { id }
        let { success, data, retInfo } = await admin_col_top_delete(params)
        if (success) {
          console.log(data)
          message.success('删除成功')
          state.queryList()
        } else {
          message.error(retInfo)
        }
      },
      handleCancel(event) {
        event.preventDefault()
        state.isVisible = false
      },
      handleConfirm() {
        // 校验skcCode不能为空
        const hasEmptySkc = state.dataSource1.some(item => !item.skcCode)
        if (hasEmptySkc) {
          message.warning('表格中存在SKC为空的行，请输入SKC或删除该行')
          return
        }
        //
        // debugger
        const params = {
          ...init.searchParams,
          colId: props.colId,
          skcs: state.dataSource1.map((e, index) => {
            return {
              priority: index + 1,
              imgUrl: e.imgUrl,
              skcCode: e.skcCode
            }
          }),
          remark: state.remark,
          id: state.id
        }

        // let { success, retInfo } = await
        admin_col_top_save(params).then(res => {
          if (res.success) {
            state.isVisible = false
            state.queryList()
            state.id = null
          } else {
            message.error(res.retInfo)
          }
        })
      },
      onChange(e, record, index) {
        const { value } = e.target
        if (!value && e.type !== 'change') {
          state.dataSource1[index] = {
            priority: state.dataSource1.length + 1,
            imgUrl: '',
            skcCode: ''
          }
        }
      },
      addAssinProduct() {
        state.dataSource1 = [
          {
            priority: 1,
            imgUrl: '',
            skcCode: ''
          }
        ]
        state.remark = ''
        state.id = null
        state.skcInputList = []
        state.isVisible = true
      },
      removeRow(index) {
        state.dataSource1.splice(index, 1)
        // state.dataSource1 = state.dataSource1.filter(
        //   e => e.skcCode !== record.skcCode
        // )
      },
      id: null,
      remark: '',
      async getDetailById(record) {
        let { success, data, retInfo } = await admin_col_top_get_detail({
          id: record.id,
          ...init.searchParams
        })
        if (success) {
          state.id = record.id
          state.dataSource1 = data.details
          state.remark = data.remark
          state.skcInputList = []
          state.isVisible = true
        } else {
          message.error(retInfo)
        }
      },
      submit(event) {
        // 即可阻止点击按钮时触发input失去焦点事件
        event.preventDefault()
        state.isVisible = false
      },
      formState: {},
      layout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      suffix:
        '?x-oss-process=image/quality,q_80/format,avif/resize,w_100,h_100',
      handleQuery() {
        state.pagination.current = 1
        state.queryList()
      },
      reset() {
        state.formState = {}
        state.handleQuery()
      },
      getPopupContainer: trigger => {
        return trigger.parentElement
      }
    })

    watchEffect(() => {
      const { terminalId } = init.searchParams

      if (terminalId === 1) {
        state.columns = [
          {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 100
          },
          {
            title: 'SkcCode',
            dataIndex: 'skcCodes',
            key: 'skcCodes',
            width: 200
          },
          {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            // ellipsis: true,
            width: 200
          },
          {
            title: '链接',
            dataIndex: 'url',
            key: 'url',
            width: 200
          },
          {
            title: '最近修改人',
            dataIndex: 'updator',
            key: 'updator',
            width: 100
          },
          {
            title: '最近修改时间',
            dataIndex: 'lastUpdateTime',
            key: 'lastUpdateTime',
            width: 200
          },
          {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: 100
          }
        ]
      } else {
        state.columns = [
          {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 100
          },
          {
            title: 'Web端TopId',
            dataIndex: 'sourceTopId',
            key: 'sourceTopId',
            width: 120
          },
          {
            title: 'SkcCode',
            dataIndex: 'skcCodes',
            key: 'skcCodes',
            width: 200
          },
          {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            // ellipsis: true,
            width: 200
          },
          // {
          //   title: '链接',
          //   dataIndex: 'url',
          //   key: 'url',
          //   width: 200
          // },
          {
            title: '最近修改人',
            dataIndex: 'updator',
            key: 'updator',
            width: 100
          },
          {
            title: '最近修改时间',
            dataIndex: 'lastUpdateTime',
            key: 'lastUpdateTime',
            width: 200
          },
          {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: 100
          }
        ]
      }
    })

    return {
      ...toRefs(state),
      dayjs,
      message
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep(.skcTitle) {
  position: relative;
  padding-left: 1em;
  &::after {
    position: absolute;
    content: '*';
    color: #ff4d50;
    left: 5px;
  }
}

.msg .err-tips {
  color: #ff4d50;
}
::v-deep(.errormsg .ant-input-affix-wrapper) {
  border-color: #ff4d50;
}
.elllipsis {
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
</style>
